import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

/**
 * 在庫・部屋一覧と同じ編集 URL。
 */
export const getRoomEditPath = ({
	hotelID,
	roomID,
	isDummyRoom,
}: {
	hotelID: string;
	roomID: string;
	isDummyRoom: boolean;
}): string => {
	if (isDummyRoom) {
		return generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DUMMY, { hotelID, roomID });
	}
	return generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DEFAULT, { hotelID, roomID });
};
